import { collectConversationDocumentIds } from 'features/knowledgeDocumentViewer/components/advancedSearch/utils/collectConversationDocumentIds'
import { MAX_CONTEXT_DOCUMENT_IDS } from 'features/knowledgeDocumentViewer/components/advancedSearch/utils/documentSearchApiSchemas'
import type {
  DocChatConversation,
  DocumentTab,
} from 'features/knowledgeDocumentViewer/types'

/** Documents the agent may read: cited or returned in the thread, then open document tabs. */
export function collectDocChatContextDocumentIds({
  conversation,
  openTabs,
  pipelineConfigId,
}: {
  conversation: DocChatConversation | undefined
  openTabs: readonly DocumentTab[]
  pipelineConfigId?: string
}): string[] {
  const ids = new Set(
    collectConversationDocumentIds(conversation, pipelineConfigId)
  )
  for (const tab of openTabs) {
    const item = tab.history[tab.currentIndex]
    if (item?.type === 'document') ids.add(item.documentId)
  }
  return Array.from(ids).slice(0, MAX_CONTEXT_DOCUMENT_IDS)
}
